import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface PanelNavItemProps {
  active: boolean;
  title: string;
  icon: LucideIcon;
  onClick: () => void;
  dimmed?: boolean;
}

export default function PanelNavItem({
  active,
  title,
  icon: Icon,
  onClick,
  dimmed = false,
}: PanelNavItemProps) {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn("h-9 w-9", {
            "dark:bg-muted dark:text-muted-foreground dark:hover:bg-muted dark:hover:text-white":
              active,
          })}
          onClick={() => onClick()}
        >
          <Icon className={cn("h-4 w-4", dimmed && "text-muted-foreground/40")} />
          <span className="sr-only">{title}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="right" className="flex items-center gap-4">
        {title}
      </TooltipContent>
    </Tooltip>
  );
}
